import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { tokenState } from "../../state";
import { getStorage, getRefreshToken } from "../../utils/util";
import { getAuthToken } from "api/auth/api";
import { getTokenWithPayload } from "utils/authUtil";
import StyledButton from "@/submodules/integration-design-system/systems/moreden/components/styled-button/StyledButton";
import PageWrapper from "@/component/PageWrapper";
import { useNavigate } from "react-router-dom";

function VerifyPending() {
  // TODO : 로그인 토큰 정보에 대한 memberType 갱신시도를 매번 해야함
  // TODO : token_status 에서 pending 인지 verify 인지 구분
  // TODO : 중간 중간 로딩해서 넘어가게 해야 함
  const [, setToken] = useRecoilState(tokenState);
  const navigate = useNavigate();

  const setTokenByRefreshToken = async () => {
    const storage = getStorage();
    const refreshToken = getRefreshToken(storage);
    const tokenData = await getAuthToken({ refresh_token: refreshToken });
    if (!tokenData) return;

    const decodedData = getTokenWithPayload(tokenData);

    storage.setItem("token", JSON.stringify(decodedData));
    setToken(decodedData);
  };

  useEffect(() => {
    setTokenByRefreshToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper widthType="narrow">
      <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4">
        <div className="text-center max-w-md mx-auto">
          {/* 성공 아이콘 */}
          <div className="mb-8">
            <div className="w-24 h-24 mx-auto mb-6 bg-primary-100 rounded-full flex items-center justify-center">
              <img
                src={`${import.meta.env.VITE_APP_PUBLIC_URL}img/img_certify_success.png`}
                alt="인증 성공"
                className="w-12 h-12"
              />
            </div>
          </div>

          {/* 메인 메시지 */}
          <div className="mb-8">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
              회원가입 신청이 완료되었습니다
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed">
              인증이 완료될 때까지 조금만 기다려주세요
            </p>
          </div>

          {/* 홈으로 돌아가기 버튼 */}
          <div className="mt-8 flex flex-col gap-2">
            <StyledButton
              size="large"
              onClick={() => (window.location.href = "/")}
              className="w-full"
            >
              홈으로 돌아가기
            </StyledButton>
            {/* 로그아웃 */}
            <StyledButton color="transparent" size="large" onClick={() => navigate("/logout")}>
              로그아웃
            </StyledButton>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default VerifyPending;
